import { Checkbox } from "@cmp-src/primitives/checkbox";
import React from "react";
import { useDataMan } from "../../hooks/useDataMan";
import { DATA_MAN_CHECKBOX_CLASS } from "./dataManCheckboxClass";

export const DataManSelectAllControl: React.FC = () => {
  const { toggleSelectAll, isAllSelected, selectedItems, data } = useDataMan();

  const hasData = data && data.length > 0;
  const isIndeterminate = selectedItems.length > 0 && !isAllSelected;

  const handleCheckedChange = React.useCallback(() => {
    toggleSelectAll();
  }, [toggleSelectAll]);

  // The column header keeps a name when there is nothing to select
  if (!hasData) {
    return <span className="sr-only">Selection</span>;
  }

  return (
    <Checkbox
      checked={isAllSelected ? true : isIndeterminate ? "indeterminate" : false}
      onCheckedChange={handleCheckedChange}
      aria-label="Select all rows"
      className={DATA_MAN_CHECKBOX_CLASS}
    />
  );
};
